import React from 'react';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown.js';
import ValidationText from '../../../utils/validation/ValidationText.js';

const ItemForm1ForStockCredit = (props) => {
    return (
        <div className="item-form">
            <div className="item-grp flex gap-2.5 mb-4">
                <div className="input-grp w-full">
                    <label>Sr. No.</label>
                    <input
                        type="text"
                        id="srNo"
                        name="srNo"
                        disabled
                        autocomplete="off"
                        value={props.invoiceDetails.srNo}
                        onChange={(event) =>
                            props.handleChange(event, "srNo", "invoiceDetails")
                        }
                    />
                </div>
                <div className="input-grp w-full">
                    <label>Invoice No.</label>
                    <input
                        type="text"
                        id="invoiceNo"
                        name="invoiceNo"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.invoiceNo}
                        onChange={(event) =>
                            props.handleChange(event, "invoiceNo", "invoiceDetails")
                        }
                    />
                    <ValidationText error={props.validState.error.invoiceNo} />
                </div>

                <div className="input-grp w-full">
                    <label>Invoice Date</label>
                    <input
                        type="date"
                        id="invoiceDate"
                        name="invoiceDate"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.invoiceDate}
                        onChange={(event) =>
                            props.handleChange(event, "invoiceDate", "invoiceDetails")
                        }
                    />
                </div>

                <div className="input-grp w-full">
                    <label>Pur. Entry No</label>
                    <input
                        type="text"
                        id="purchaseEntryNo"
                        name="purchaseEntryNo"
                        className="inputFocus w-full"
                        autocomplete="off"
                        value={props.invoiceDetails.purchaseEntryNo}
                        onChange={(event) =>
                            props.handleChange(
                                event,
                                "purchaseEntryNo",
                                "invoiceDetails"
                            )
                        }
                    />
                </div>
                <div className="input-grp w-full">
                    <label>Invoice Type</label>
                    <select
                        name="invoiceType"
                        value={props.invoiceDetails.invoiceType}
                        onChange={(e) =>
                            props.handleDropDownChangeForFirstForm(e, "invoiceType")
                        }
                    >
                        <option>Select</option>
                        {props.invoiceTypeList.map((x, key) => (
                            <option key={key} value={x.invoiceType}>
                                {x.invoiceType}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="input-grp min-w-[30%]">
                    <label>Party Name</label>
                    <MultiSelectDropdown
                        drpIdentity="partyId"
                        options={props.partyDropdownList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                            props.setFilterParameters(selected, "partyId")
                        }
                        allowSelectAll={false}
                        value={props.partyDropdownList.filter(
                            (party) =>
                                party.value === props.invoiceDetails.partyId
                        )}
                    />
                    <ValidationText error={props.validState.error.partyId} />
                </div>
            </div>
            <div className="item-grp flex mb-4">
                <div className="input-grp flex items-center">
                    <input
                        className="inputFocus mr-[8px] !w-[18px] h-[18px]"
                        type="checkbox"
                        name="isPurchaseEntry"
                        id="isPurchaseEntry"
                        autocomplete="off"
                        value={props.invoiceDetails.isPurchaseEntry}
                        checked={props.invoiceDetails.isPurchaseEntry}
                        onChange={(event) =>
                            props.handleCheckbox(event, "isPurchaseEntry")
                        }
                    />
                    <label className="!mb-0">Purchase Entry</label>
                </div>
            </div>
        </div>
    );
};

export default ItemForm1ForStockCredit;